import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import ButtonActions from "../inventory/buttonsActions";
import EditIcon from "@material-ui/icons/Edit";
import Request from "../../utils/http";
import NewProduct from "./newProduct";

const request = new Request();

function Product() {
  //set de valores
  const [products, setProducts] = useState([]);
  //obteneos token
  let token1 = JSON.parse(sessionStorage.getItem("decoAdmin"));
  let token;
  if (token1) {
    token = token1.id;
  }
  useEffect(() => {
    getProduct();
  }, []);

  const getProduct = async () => {
    let data = {
      token: token
    };
    const response = await request.post("/auth/purchases/getComprasProduct", data);

    //validar los datos que recibimos
    if (response && !response.error) {
      if (response.result && !response.empty) {
        setProducts(response.result);
      } else {
        console.log(response.result.message);
      }
    } else {
      console.log("error en la peticion");
    }
  };

  const columns = [
    {
      name: "actions",
      label: "ACCIONES",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              <NewProduct
                edit={true}
                reload={getProduct}
                id={tableMeta.rowData[1]}
              ></NewProduct>
            </div>
          );
        }
      }
    },
    {
      name: "id_prod",
      label: "ID",
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: "nombreProducto",
      label: "NOMBRE",
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: "caracteristicas",
      label: "CARACTERISTICAS",
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: "unidad",
      label: "UNIDAD",
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: "den_com",
      label: "PROVEEDOR",
      options: {
        filter: true,
        sort: true
      }
    },

    {
      name: "nombre_categoria",
      label: "SUBCATEGORIA",
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: "nombre_subcategoria",
      label: "SUBCATEGORIA",
      options: {
        filter: true,
        sort: true
      }
    }
  ];

  const options = {
    selectableRows: "none",
    filter: false,
    viewColumns: false,
    textLabels: {
      body: {
        noMatch: "No se encontraron resultados.",
        toolTip: "Sort"
      },
      pagination: {
        next: "Siguiente",
        previous: "Anterior",
        rowsPerPage: "Número de filas:",
        displayRows: "de"
      },
      toolbar: {
        search: "Buscar",
        downloadCsv: "Descargar Excel",
        print: "Imprimir"
      },
      filter: {
        all: "TODOS",
        title: "FILTROS",
        reset: "LIMPIAR"
      },
      viewColumns: {
        title: "Mostar Columnas",
        titleAria: "Mostrar/Ocultar Columnas de la Tabla"
      },
      selectedRows: {
        text: "Fila(s) Seleccionadas",
        delete: "Eliminar",
        deleteAria: "Eliminar Filar Seleccionadas"
      }
    },
    customToolbar: () => {
      return <NewProduct edit={false} reload={getProduct} id_prov={0}/>;
    }
  };

  return (
    <MUIDataTable
      title={"LISTA DE PRODUCTOS"}
      data={products}
      columns={columns}
      options={options}
    />
  );
}
export default Product;
